// src/components/LoadingScreen.jsx
import React from 'react';
import { Infinity } from 'ldrs/react';
import 'ldrs/react/Infinity.css';

const LoadingScreen = () => {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#ffffff', // White background
    }}>
      <Infinity
        size="150"
        stroke="10"
        strokeLength="0.15"
        bgOpacity="0.3"
        speed="1.3"
        color="url(#customGradient)" // Reference to custom gradient
      />
      <svg width="0" height="0">
        <defs>
          <linearGradient id="customGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f97794" />
            <stop offset="50%" stopColor="#6200ff" />
            <stop offset="100%" stopColor="#3498db" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default LoadingScreen;
